/**************************************************
 * Nombre:       Home_Articulos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import TituloHuella from "./SubComponentes/TituloHuella";
import Lista_Recomendaciones from "./SubComponentes/Lista_Recomendaciones";
import {useEffect, useState} from "react";
import {collection, limit, orderBy, query, where} from "firebase/firestore";
import {fire} from "../../../fire";
import {obtenerColeccionQuery} from "../../../Servicios/BD/obtenerColeccionQuery";

const Home_Articulos = () => {
    const [recientes, setRecientes] = useState([]);


    useEffect(() => {

        let q = query(collection(fire, 'blogs'), where('estado', '==', 'Publicado'),
            orderBy('fechaPublicacion', 'desc'),
            limit(3)
        )

        obtenerColeccionQuery(q).then((dox) => {
            if (dox.res) {
                setRecientes(dox.data);
            }
        })

    }, [])
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <TituloHuella titulo={'Recomendaciones'}/>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 4}}>
                            <Lista_Recomendaciones items={recientes} />
                        </Grid>


                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Articulos